import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';


const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => (
      import('./pages/home/home.module')
        .then(m => m.HomePageModule)
    )
  },
  {
    path: 'signup',
    loadChildren: () => (
      import('./pages/signup/signup.module')
        .then( m => m.SignUpPageModule)
    )
  },
  {
    path: 'categories',
    loadChildren: () => (
      import('./pages/categories/categories.module')
        .then( m => m.CategoriesPageModule)
    )
  },
  {
    path: 'products/:id',
    loadChildren: () => (
      import('./pages/products/products.module')
        .then( m => m.ProductsPageModule)
    )
  },
  {
    path: 'product-detail/:id',
    loadChildren: () => (
      import('./pages/product-detail/product-detail.module')
        .then( m => m.ProductDetailPageModule)
    )
  },
  {
    path: 'cart',
    loadChildren: () => (
      import('./pages/cart/cart.module')
        .then( m => m.CartPageModule)
    )
  },
  {
    path: 'profile',
    loadChildren: () => (
      import('./pages/profile/profile.module')
        .then( m => m.ProfilePageModule)
    )
  },
  {
    path: 'pick-address',
    loadChildren: () => (
      import('./pages/pick-address/pick-address.module')
        .then( m => m.PickAddressPageModule)
    )
  },
  {
    path: 'payment/:address',
    loadChildren: () => (
      import('./pages/payment/payment.module')
        .then( m => m.PaymentPageModule)
    )
  },
  {
    path: 'client-order-confirmation/:order',
    loadChildren: () => (
      import('./pages/client-order-confirmation/client-order-confirmation.module')
        .then( m => m.ClientOrderConfirmationPageModule)
    )
  },
];


/**
 * Responsible for handling application routes.
 */
@NgModule({
  imports: [
    RouterModule.forRoot(
      routes, 
      { preloadingStrategy: PreloadAllModules }
    )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
